<script setup>
import { useI18n } from 'vue-i18n'

import AppleSvg from '@/components/svg/AppleSvg.vue'
import GooglePlaySvg from '@/components/svg/GooglePlaySvg.vue'

import OpineoPlSvg from '@/components/svg/footer/media/pl/OpineoPlSvg.vue'
import ShopRokuSvg from '@/components/svg/footer/media/ShopRokuSvg.vue'
import MediaSvg from '@/components/svg/footer/MediaSvg.vue'
import ZacinajiciPodnikatelSvg from '@/components/svg/footer/media/ZacinajiciPodnikatelSvg.vue'
import FooterAnpc from "@/components/footer/FooterAnpc.vue";

const { t, locale } = useI18n()
</script>

<template>
  <div class="row c-mx-0 c-px-0 c-items-start">
    <div class="flex ml-n1 c-sm:c-ml-0">
      <a
        href="https://apps.apple.com/cz/app/mixit/id6444029029"
        class="!no-underline flex btn btn-outline-light border-1 c-rounded-pill font-bold footer-app-link text-md-c c-sm:c-mr-2 c-mr-1 text-left"
        target="_blank"
      >
        <span class="app-link-icon flex border border-light border-1 c-items-center c-justify-center c-rounded-circle c-mr-2">
          <AppleSvg class="i-apple" />
        </span>
        App Store
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=cz.mixit.app"
        class="!no-underline flex btn btn-outline-light border-1 c-rounded-pill font-bold footer-app-link text-md-c text-left"
        target="_blank"
      >
        <span class="app-link-icon flex border border-light border-1 c-items-center c-justify-center c-rounded-circle c-mr-2">
          <GooglePlaySvg />
        </span>
        Google Play
      </a>
    </div>
    <div class="c-lg:c-ml-auto col-12 c-lg:col-auto">
      <ul class="row list-unstyled ml-n4 c-mb-0">
        <li
          v-if="locale === 'cs' || locale === 'sk'"
          class="col-auto c-pr-5 flex c-lg:c-mt-0 c-mt-5"
        >
          <span class="c-mt-2">
            <MediaSvg
              width="34"
              height="29"
            />
          </span>
          <div class="c-pl-2 text-primary-100">
            <span class="font-bold block text-md-c c-mt-1">{{ t('what_media_wrote_about_us') }}</span>
            <router-link
              :to="{ name: 'mediaPath' }"
              aria-label="Media"
              class="c-mt-2"
            >
              {{ t('go_to_articles') }}
            </router-link>
          </div>
        </li>
        <li
          v-if="locale === 'cs' || locale === 'sk'"
          class="col-auto c-pr-5 c-lg:c-mt-0 c-mt-5"
        >
          <ShopRokuSvg
            width="162"
            height="50"
          />
        </li>
        <li
          v-if="locale === 'cs' || locale === 'sk'"
          class="col-auto c-pr-0 c-lg:c-mt-0 c-mt-5"
        >
          <ZacinajiciPodnikatelSvg
            width="147"
            height="50"
          />
        </li>
        <li
          v-if="locale === 'pl'"
          class="col-auto c-pl-5 c-pr-0"
        >
          <OpineoPlSvg
            width="65"
            height="60"
          />
        </li>
        <li
          v-if="locale === 'ro'"
          class="col-auto c-pr-0 c-lg:c-mt-0 c-mt-5"
        >
          <FooterAnpc />
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.footer-app-link {
  padding: 5px 16px 5px 5px;

  &:hover {
    .app-link-icon {
      background-color: $primary;
    }
  }

  .app-link-icon {
    width: 30px;
    height: 30px;
    background-color: #ee9e3e4d;
    transition: .15s background-color;

    .i-apple {
      margin-top: -1px;
    }
  }
}
</style>

<i18n>
  {
    "cs": {
    "go_to_articles": "Jít na články",
    "what_media_wrote_about_us": "Co o nás píší média?"
},
    "sk": {
    "go_to_articles": "Prezerať médiá o nás",
    "what_media_wrote_about_us": "Čo o nás hovoria médiá?"
},
    "pl": {
    "go_to_articles": "Przejdź do artykułów",
    "what_media_wrote_about_us": "Co mówią o nas media?"
},
    "hu": {
    "go_to_articles": "Ugrás a cikkekhez",
    "what_media_wrote_about_us": "Mit ír rólunk a média?"
},
    "de": {
    "go_to_articles": "zum Artikel",
    "what_media_wrote_about_us": "Was schreiben die Medien über uns?"
},
    "at": {
    "go_to_articles": "zum Artikel",
    "what_media_wrote_about_us": "Was schreiben die Medien über uns?"
},
    "ro": {
    "go_to_articles": "Accesați articole",
    "what_media_wrote_about_us": "Ce scrie mass-media despre noi?"
},
    "fr": {
    "go_to_articles": "Accéder aux articles",
    "what_media_wrote_about_us": "Dans les médias."
},
    "it": {
    "go_to_articles": "Vai agli articoli",
    "what_media_wrote_about_us": "Cosa scrivono di noi i media?"
}
  }
</i18n>

